module.exports = {
	"IMOMO_CENTRAL_ASIA": "iEasyHydro",
	"USERNAME_OR_PASSWORD_WRONG": "Имя пользователя и пароль неверные.",
	"USER_NOT_APPROVED_ORGANIZATION": "Пользователь не был одобрен организацией.",
	"H_Q_TABLE": "H/Q Таблица",
	"MINIMUM_H_CM": "Минимальный H (см)",
	"MAXIMUM_H_CM": "Максимальный H (см)",
	"MINIMUM_Q_M3_S": "Минимальный Q (м<sup>3</sup>/с)",
	"MAXIMUM_Q_M3_S": "Максимальный Q (м<sup>3</sup>/с)",
	"APPLY": "подать заявление",
	"DISCHARGE_DATA": "Данные расхода воды",
	"DELETE_SELECTED_ARTIFICIAL_DATA": "Удалить искусственный расход воды",
	"DATE": "Дата",
	"WATER_LEVEL": "Уровень воды",
	"DISCHARGE": "Расход воды",
	"CM": "см",
	"M3_S": "м<sup>3</sup>/с",
	"ADD_DISCHARGE_DATA_POINT": "Ввод расхода воды",
	"H_CM": "H (см)",
	"Q_M3_S": "Q (м<sup>3</sup>/с)",
	"H_CM_OLD": "H (см) - старый",
	"Q_M3_S_OLD": "Q (м<sup>3</sup>/с) - старый",
	"CANCEL": "Отмена",
	"ADD": "Добавить",
	"DISCHARGE_MODELS": "Модели кривой расходов воды",
	"SHOW_HIDDEN_MODELS": "Показать скрытые модели",
	"DELETE_DISCHARGE_MODEL": "Удалить модель расходов воды",
	"DELETE_DISCHARGE_MODEL_EXTENDED": "Удаление модели расходов воды будет пересчитывать любые связанные значения расходов воды с использованием предыдущей модели. Это действие является постоянным.",
	"DELETE": "Удалить",
	"NON_EXISTENT_STATION_CODE": "Несуществующий индекс станции",
	"NON_EXISTENT_STATION_CODE_EXTENDED": "В системе нет станции с индексом {stationCode}",
	"FORBIDDEN_STATION_CODE": "Запрещенный индекс станции",
	"FORBIDDEN_STATION_CODE_EXTENDED": "Станция с индексом {stationCode} принадлежит другой организации.",
	"UNEXPECTED_ERROR": "Неожиданная ошибка",
	"UNEXPECTED_ERROR_EXTENDED": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте еще раз, и если ошибка не устранена, обратитесь в службу поддержки.",
	"OK": "OK",
	"TRY_AGAIN": "Попробуйте снова",
	"ACCOUNT": "Аккаунт",
	"ORGANIZATION": "Организация",
	"LOG_IN": "Авторизоваться",
	"LOG_OUT": "Выйти",
	"MENU": "Меню",
	"HOME": "Домой",
	"TOOLS": "Инструменты",
	"OPERATIONAL_HYDROLOGY": "Оперативная гидрология",
	"DISCHARGE_FORECASTING": "Прогноз стока рек",
	"STATION_MANAGEMENT": "Управление гидропостами",
	"HELP": "Помощь",
	"FEEDBACK": "Обратная связь",
	"SETTINGS": "Установки",
	"ABOUT_US": "О нас",
	"USERS": "Пользователи",
	"IMOMO_HYDROMETEOROLOGY": "iMoMo Гидрометеорология",
	"WELCOME_BACK": "Добро пожаловать назад!",
	"CLOUD_AUTOMATED_WORKSTATION_OF_THE_OPERATIONAL_HYDROLOGIST": "Облачное автоматизированное рабочее место (АРМ) оперативного гидролога",
	"1_PROCESSING_OF_KH_15_TELEGRAMS_WITH_DAILY_HYDROLOGICAL_DATA": "1. Обработка ежедневных сводок (телеграммы КН-15).",
	"2_CREATION_AND_MODIFICATION_OF_OPERATIONAL_DISCHARGE_RATION_CURVES": "2. Ведение (построение и изменение) оперативных кривых расходов.",
	"3_CALCULATION_OF_CURRENT_AND_DAILY_AVERAGE_HYDROLOGICAL_VALUES": "3. Ведение ежедневного оперативного журнала.",
	"4_RELEASE_OF_THE_DAILY_HYDROLOGICAL_BULLETIN": "4. Выпуск ежедневного гидрологического бюллетеня.",
	"5_HYDROLOGICAL_FORECASTING": "5. Гидрологическое прогнозирование (ежедневное, пентадное, декадное, месячное и сезонное)",
	"NAME": "Имя",
	"ADDRESS": "Адрес",
	"ADMIN_USER": "Администратор",
	"USER_DETAILS": "Данные пользователя",
	"USERNAME": "Имя пользователя",
	"PASSWORD": "Пароль",
	"REPEAT_PASSWORD": "Повторить пароль",
	"NEW_PASSWORD": "Новый пароль",
	"REPEAT_NEW_PASSWORD": "Повторить новый пароль",
	"EMAIL": "Эл.почта",
	"EDIT_USER": "Редактировать пользователя",
	"ADD_USER": "Добавить пользователя",
	"SAVE": "Сохранить",
	"DELETING": "Удаление",
	"SAVING": "Сохранение",
	"BACK": "Назад",
	"ROLE": "Роль",
	"DELETE_USER": "Удалить пользователя?",
	"DELETE_ORGANIZATION": "Удалить организацию?",
	"DELETE_FORECAST_MODEL": "Удалить прогностическую модель?",
	"DELETE_CONFIRMATION": "Вы уверены, что хотите удалить {item}?",
	"THIS_FIELD_IS_REQUIRED": "Это поле обязательно к заполнению",
	"THE_VALUE_IS_TOO_LONG": "Значение слишком длинное.",
	"THE_VALUE_IS_TOO_SHORT": "Значение слишком короткое.",
	"LOGIN": "Логин",
	"CREATE_NEW_USER": "Создать нового пользователя",
	"LOG_IN_AS_GUEST": "Войти как гость",
	"FORGOT_YOUR_PASSWORD": "Забыли пароль?",
	"ANNOUNCEMENTS": "Уведомление",
	"OPERATIONAL_DATA_INPUT": "Ввод оперативных данных",
	"ENTER_TELEGRAM": "Ввод телеграмм",
	"OPERATIONAL_JOURNAL": "Оперативный журнал",
	"VIEW_JOURNAL": "Просмотр журнала",
	"DAILY_OPERATIONAL_BULLETIN": "Ежедневный гидрологический бюллетень",
	"GENERATE_BULLETIN": "Формирование бюллетеня",
	"TELEGRAM": "Телеграмма",
	"DISCHARGE_CURVE": "Кривая расходов воды",
	"SAVE_DATA": "Сохранить данные",
	"NEXT": "Следующий",
	"PREVIOUS": "предыдущий",
	"SUBMIT_DATA": "Принять данные",
	"KN15_TELEGRAM": "КН-15 телеграмма",
	"STATION": "Гидропост",
	"PROCESS_TELEGRAM": "Обработка телеграммы",
	"TELEGRAM_IS_REQUIRED": "Телеграмма обязательна.",
	"M2": "м<sup>2</sup>",
	"REPORTED_WATER_LEVEL": "Поступивший уровень вода",
	"PREVIOUS_DAY": "За предыдушие сутки",
	"TELEGRAM_DAY": "Текущие сутки",
	"8_AM": "8:00",
	"8_PM": "20:00",
	"DAILY_AVERAGE": "Среднесуточный",
	"DAILY_CHANGE": "Тенденция",
	"WATER_LEVEL_TREND_IS_CORRECT": "Тенденция уровня воды неправильная.",
	"WATER_LEVEL_TREND_WRONG": "Water level trend could not be verified or is wrong.",
	"REPORTED_DISCHARGE": "Поступившый замер расхода воды",
	"CROSS_SECTION_AREA": "Площадь живого сечения",
	"MAXIMUM_DEPTH": "Максимальная глубина",
	"ICE_PHENOMENA": "Ледовые явления",
	"CODE": "Код",
	"DESCRIPTION": "Описание",
	"INTENSITY": "Интенсивность",
	"DISCHARGE_CALCULATION_DISABLED": "Discharge calculation disabled",
	"ADJUST_DISCHARGE_MODEL": "Настройка модели кривой расходов",
	"IDENTIFIER": "Идентификатор",
	"ADD_DELTA_H": "Ввести \\u0394H",
	"FIT_TO_SELECTED_DATA": "Подбор выбранных данных",
	"REFERENCE_MODEL": "Эталонная модель",
	"DELTA_H": "\\u0394H",
	"DATA_SELECTED": "{count, plural, =0{Точки данных не выбраны.} one{Выберите еще одну точку данных.} other{{count} точки данных выбраны.} }",
	"NO_NEW_MODEL": "Нет новой модели кривой",
	"VALID_FROM": "Действителен с",
	"CREATE_MODEL": "Создать модель",
	"DELETE_MODEL": "Удалить модель кривой",
	"DISCHARGE_MODEL": "Модель кривой расходов воды",
	"PROCESSED_DATA": "Обработанные данные",
	"AVERAGE": "Среднее",
	"MONTH": "Месяц",
	"YEAR": "Год",
	"LOAD_JOURNAL": "Загрузить журнал",
	"DAILY_DATA": "Ежедневные данные",
	"TREND": "Тенденция",
	"WATER_CELSIUS": "Вода (℃)",
	"AIR_CELSIUS": "Воздух (℃)",
	"ICE": "Лед",
	"MINIMUM": "Минимальный",
	"MAXIMUM": "Максимальный",
	"EDIT_SELECTED_ROW": "Изменить выбранную строку",
	"EDIT_DAILY_DATA_ROW": "Изменить строку ежедневных данных",
	"APPLY_CHANGES": "Применить изменения",
	"H_8_AM": "H (8:00)",
	"H_8_PM": "H (20:00)",
	"H_AVERAGE": "H (Среднее)",
	"DAILY_DATA_WAS_EDITED": "Ежедневные данные были отредактированы.",
	"ERROR_UPDATING_DATA": "Произошла ошибка при обновлении данных. Пожалуйста, попробуйте еще раз.",
	"DELETE_SELECTED_ROW_FROM_DATABASE": "Удалить выбранную строку из базы данных",
	"F_M2": "F (м2)",
	"EDIT_METEO_ROW": "Edit meteo row",
	"EDIT_DISCHARGE_ROW": "Изменить строку расхода воды",
	"METEO_DATA_WAS_EDITED": "Meteo data was edited.",
	"DISCHARGE_DATA_WAS_EDITED": "Расход воды был отредактирован.",
	"ERROR_UPDATING_DISCHARGE_DATA": "Произошла ошибка при обновлении рахода воды. Пожалуйста, попробуйте еще раз.",
	"DELETE_DISCHARGE_DATA": "Удалить расход воды",
	"DELETE_DATA_WARNING": "Вы уверены, что хотите удалить эти данные? Это действие является постоянным.",
	"DISCHARGE_DATA_WAS_DELETED": "Расход воды был удален",
	"ERROR_DELETING_DISCHARGE_DATA": "Произошла ошибка при удалениирасхода воды. Пожалуйста, попробуйте еще раз.",
	"DECADAL_DATA": "Декадные данные",
	"DECADE": "Декада",
	"MONTHLY_AVERAGE": "Средние месячные",
	"OPERATIONAL_BULLETIN": "Оперативный бюллетень",
	"BULLETIN_DATE": "Дата выпуска бюллетеня",
	"PREPARE_BULLETIN": "Подготовить бюллетень",
	"DOWNLOAD_BULLETIN": "Скачать бюллетень",
	"HYDROLOGICAL_DISCHARGE_STATIONS": "Гидрологические посты",
	"STATION_CODE": "Индекс поста",
	"STATION_NAME": "Название поста",
	"REGION": "Область",
	"RIVER_BASIN": "Речной бассейн",
	"ADD_STATION": "Добавить гидропост",
	"EDIT_STATION": "Редактировать гидропост",
	"SHOW_DISCHARGE_CURVES": "Показать кривую расходов воды",
	"SHOW_DISCHARGE_TIME_SERIES": "Показать исторические расходв воды",
	"SHOW_HISTORIC_DATA": "Проказать исторические данные",
	"STEP_1_DETAILS": "Шаг 1: Детальная информация",
	"STATION_DETAILS": "Детальная информация станции",
	"LOCAL_CODE": "Индекс",
	"BASIN": "Бассейн",
	"COUNTRY": "Страна",
	"LOCATION": "Расположение",
	"MAXIMUM_DISCHARGE_LEVEL_M3_S": "Опасный расход воды (м3/с)",
	"VALUE_IS_REQUIRED": "Требуется значение.",
	"INVALID_VALUE": "Неверное значение.",
	"VERIFYING": "Проверка ...",
	"CODE_IS_ALREADY_USED": "Индекс уже используется.",
	"VALUE_IS_TOO_LONG": "Значение слишком длинное",
	"STEP_2_AGGREGATIONS": "Шаг 2: Агрегации",
	"STEP_2_DISCHARGE_CURVE": "Шаг 2: Кривая расходов воды",
	"DISCHARGE_POINTS": "Точки расходов воды",
	"WATER_LEVEL_CM": "Уровень воды (см)",
	"DISCHARGE_M3_S": "Расход воды (м3/с)",
	"EG_INITIAL_STATION_MODEL": "Например. Начальная модель гидропоста",
	"SHOW_H_Q_TABLE": "Показать H/Q таблицу",
	"AN_IDENTIFIER_IS_REQUIRED": "Требуется идентификатор.",
	"IDENTIFIER_IS_TOO_LONG": "Идентификатор слишком длинный.",
	"MODEL_H_Q_TABLE": "H/Q таблица",
	"STEP_3_HISTORICAL_DISCHARGE_DATA": "Шаг 3: Исторические данные расходов воды",
	"HISTORICAL_DISCHARGE_DATA_UPLOAD": "Загрузка исторических данных",
	"PLEASE_UPLOAD_HISTORICAL_METEO": "Пожалуйста, загрузите исторические декадные метеоданные для станции.",
	"PLEASE_UPLOAD_HISTORICAL": "Пожалуйста, загрузите исторические декадные расходы воды для гидропоста.",
	"DATA_AVAILABLE_FOR_DOWNLOAD": "Данные всегда будут доступны для скачивания и могут быть обновлены в любое время.",
	"DATA_MUST_BE_EXCEL": "Данные должны быть загружены как файл Excel (.xls / .xlsx) в том же формате, что и файл примера.",
	"NO_FILE_SELECTED": "Файл не выбран",
	"DOWNLOAD_EXAMPLE_FILE": "Скачать файл примера",
	"SELECT_FILE": "Выберите файл",
	"CHANGE": "Изменить",
	"VALIDATE": "Утвердить",
	"VALIDATED": "Утвержденный",
	"STEP_4_REVIEW_AND_CREATE": "Шаг 4. Просмотр и создание",
	"CREATE_STATION": "Создать станцию",
	"STATUS": "Статус",
	"HISTORICAL_DISCHARGE_DATA": "Исторические расходы воды",
	"DONE": "Готово",
	"PENDING": "В ожидании",
	"CREATE": "Создать станцию",
	"STATION_LIST": "Список станций",
	"SELECT_A_STATION": "Выбрать станцию",
	"DISCHARGE_NORM": "Нормы расходов воды",
	"I": "I",
	"II": "II",
	"III": "III",
	"NEW_DATA_MUST_BE_EXCEL": "Новые данные должны быть загружены как файл Excel (.xls / .xlsx) в том же формате, что и файл примера.",
	"DOWNLOAD_DATA": "Скачать данные",
	"UPLOAD_NEW_DATA": "Загрузить новые данные",
	"HYDROLOGICAL_YEAR": "Гидрологический год",
	"CHANGE_YEAR": "Сменить год",
	"NEW_DISCHARGE_MODEL": "Новая модель кривой расходов воды",
	"MODEL_IDENTIFIER": "Идентификатор модели",
	"NEW_MODEL": "Новая модель",
	"SAVE_NEW_MODEL": "Сохранить новую модель",
	"MEASURED_PRECIPITATION_TIME_SERIES": "Ряд данных измеренных осадов",
	"MEASURED_TEMPERATURE_TIME_SERIES": "Ряд данных измеренных темепарур воздуха",
	"MEASURED_DISCHARGE_TIME_SERIES": "Ряд данных расходов воды",
	"LOAD_GRAPH": "Загрузить график",
	"INITIAL_YEAR": "Начальный год",
	"FINAL_YEAR": "Конечный год",
	"HISTORICAL_NORM": "Нормы",
	"RESET": "Сброс",
	"SAVE_CHANGES": "Сохранить изменения",
	"PHONE": "Телефон",
	"REQUEST_ACCESS": "Запрос доступа",
	"ADD_ORGANIZATION": "Добавить организацию",
	"AGGREGATION": "Агрегирование",
	"WEIGHTING": "Придать вес",
	"ORGANIZATION_NAME": "Название организации",
	"ORGANIZATION_ADDRESS": "Адрес организации",
	"CITY": "Город",
	"ZIP_CODE": "Почтовый индекс",
	"ADMINISTRATORS": "Администраторы",
	"NO_ADMINS": "В этой организации нет администраторов.",
	"SEND": "Послать",
	"RESET_PASSWORD": "Сброс пароля",
	"RESETING": "Сброс",
	"PASSWORDS_NOT_MATCHING": "Пароли не совпадают.",
	"CHANGE_PASSWORD": "Изменить пароль",
	"OLD_PASSWORD": "Старый пароль",
	"PROCESSING": "Обработка ...",
	"NO_STATIONS": "Гидропосты не найдены",
	"SEARCH_STATIONS_PLACEHOLDER": "Поиск станции по 'siteName' или 'siteCode'",
	"ADD_VIRTUAL_STATION": "Добавить виртуальную станцию",
	"VIRTUAL_STATION": "Виртуальная станция",
	"EDIT_ORGANIZATION": "Редактировать организацию",
	"DISCHARGE_STATIONS": "Гидропосты",
	"METEOSTATIONS": "Метеостанция",
	"HISTORICAL_DATA": "Исторические данные",
	"STEP_2_HISTORICAL_DATA": "Шаг 2: Исторические данные",
	"ADD_METEOSTATION": "Добавить метеостанцию",
	"SHOW_TIME_SERIES": "Показать ряды данных",
	"EDIT_METEOSTATION": "Редактировать метеостанцию",
	"HYDROLOGICAL_METEOSTATIONS": "Гидропосты",
	"HISTORICAL_PRECIPITATION_DATA": "Исторические данные о осадках",
	"HISTORICAL_TEMPERATURE_DATA": "Исторические данные о температуре воздуха",
	"PRECIPITATION": "Осадки",
	"TEMPERATURE": "Температура воздуха",
	"NAME_IS_ALREADY_USED": "Имя уже используется.",
	"STEP": "Шаг {stepNumber}:",
	"FORECAST_MODEL_LIST": "Список моделей прогноза",
	"TYPE_NEW_FORECAST_MODEL_NAME": "Введите имя новой модели",
	"LEAVE_EMPTY_NO_FORECAST": "Оставьте пустым, если прогноз не требуется",
	"FORECAST_SETTINGS": "Настройки прогноза",
	"FORECAST_PARAMETERS": "Параметры прогноза",
	"FREQUENCY": "Частота",
	"METHOD": "Метод",
	"METHOD_PARAMETERS": "Параметры метода",
	"MODEL_PARAMETERS": "Параметры модели",
	"DATASETS_USED": "Используемые наборы данных",
	"TRAIN_AND_ASSESS_MODEL": "Модель Train & Assess",
	"CURRENT_FORECASTING_PERIOD": "Текущий период прогнозирования",
	"FORECAST_NAME": "Название прогноза",
	"FORECAST_ISSUE_DATES": "Даты выпуска прогноза",
	"5_DAY": "Пентада",
	"DECADAL": "Декадные данные",
	"MONTHLY": "Месячные",
	"SEASONAL": "Сезонные",
	"1ST_DAY_OF_FORECASTED_PERIOD": "1-й день прогнозируемого периода",
	"ONE_DAY_BEFORE_FORECASTED_PERIOD": "За день до прогнозируемого периода",
	"TWO_DAYS_BEFORE_FORECASTED_PERIOD": "За два дня до прогнозируемого периода",
	"THREE_DAYS_BEFORE_FORECASTED_PERIOD": "Три дня до прогнозируемого периода",
	"RELATIVE": "Относительный",
	"START_DATE": "Дата начала",
	"END_DATE": "Дата окончания",
	"ISSUE_DATE": "Дата выпуска",
	"SEASONAL_FREQUENCY_SETTINGS": "Настройки сезонной частоты",
	"VALUES": "Значения",
	"EVALUATION_STATISTICS": "Оценка статистики",
	"DISCHARGE_CHARACTERISTICS": "Характеристики расходов воды",
	"FORECAST_VALUE": "Прогнозное значение",
	"PREVIOUS_VALUE": "Предыдущее значение",
	"NUMBER_OF_TRAINING_DATA": "Количество тренировочных данных",
	"ACCEPT": "Принять",
	"ACCESS": "Доступ",
	"HYDROLOGICAL_STATIONS_WITH_FORECASTING": "Гидропосты с прогнозированием",
	"PERCENTAGE": "Процент",
	"RELATIVE_ERROR": "Относительная ошибка",
	"STANDARD_DEVIATION": "Стандартное отклонение",
	"NORM": "Норма",
	"ICE_PHENOMENA_11": "Сало",
	"ICE_PHENOMENA_12": "Снежура",
	"ICE_PHENOMENA_13": "Забереги",
	"ICE_PHENOMENA_14": "Припай",
	"ICE_PHENOMENA_15": "Забереги нависшие",
	"ICE_PHENOMENA_16": "Ледоход",
	"ICE_PHENOMENA_17": "Ледоход",
	"ICE_PHENOMENA_18": "Ледоход поверх ледяного покрова",
	"ICE_PHENOMENA_19": "Шугоход",
	"ICE_PHENOMENA_20": "Внутриводный лед",
	"ICE_PHENOMENA_21": "Пятры",
	"ICE_PHENOMENA_22": "Осевший лед",
	"ICE_PHENOMENA_23": "Навалы льда на берегах",
	"ICE_PHENOMENA_24": "Ледяная перемычка в створе поста",
	"ICE_PHENOMENA_25": "Ледяная перемычка выше поста",
	"ICE_PHENOMENA_26": "Ледяная перемычка ниже поста",
	"ICE_PHENOMENA_30": "Затор льда выше поста",
	"ICE_PHENOMENA_31": "Затор льда ниже поста",
	"ICE_PHENOMENA_32": "Затор льда искусственно разрушается",
	"ICE_PHENOMENA_34": "Зажор льда выше поста",
	"ICE_PHENOMENA_35": "Зажор льда ниже поста",
	"ICE_PHENOMENA_36": "Зажор льда искусственно разрушается",
	"ICE_PHENOMENA_37": "Вода на льду",
	"ICE_PHENOMENA_38": "Вода течет поверх льда",
	"ICE_PHENOMENA_39": "Закраина",
	"ICE_PHENOMENA_40": "Лед потемнел",
	"ICE_PHENOMENA_41": "Снежница",
	"ICE_PHENOMENA_42": "Лед подняло",
	"ICE_PHENOMENA_43": "Подвижка льда",
	"ICE_PHENOMENA_44": "Разводья",
	"ICE_PHENOMENA_45": "Лед тает на место",
	"ICE_PHENOMENA_46": "Забереги остаточные",
	"ICE_PHENOMENA_47": "Наслуд",
	"ICE_PHENOMENA_48": "Битый лед",
	"ICE_PHENOMENA_49": "Блинчатый лед",
	"ICE_PHENOMENA_50": "Ледяные поля",
	"ICE_PHENOMENA_51": "Ледяная каша",
	"ICE_PHENOMENA_52": "Стамуха",
	"ICE_PHENOMENA_53": "Лед относит от берега",
	"ICE_PHENOMENA_54": "Лед прижимает к берегу",
	"ICE_PHENOMENA_63": "Ледостав неполный",
	"ICE_PHENOMENA_64": "Ледяной покров с полыньями",
	"ICE_PHENOMENA_65": "Ледостав, ровный ледяной покров",
	"ICE_PHENOMENA_66": "Ледостав, ледяной покров с торосами",
	"ICE_PHENOMENA_67": "Ледяной покров с грядами торосов",
	"ICE_PHENOMENA_68": "Шуговая дорожка",
	"ICE_PHENOMENA_69": "Подо льдом шуга",
	"ICE_PHENOMENA_70": "Трещины в ледяном покрове",
	"ICE_PHENOMENA_71": "Наледь",
	"ICE_PHENOMENA_72": "Лед нависший",
	"ICE_PHENOMENA_73": "Лед ярусный",
	"ICE_PHENOMENA_74": "Лед на дне",
	"ICE_PHENOMENA_75": "Река промерзла",
	"ICE_PHENOMENA_76": "Лед искусственно разрушен",
	"ICE_PHENOMENA_77": "Наледная вода",
	"KN15_ERRORS_TOO_SHORT_TOKEN": "Группы телеграммы должны иметь 5 символов.",
	"KN15_ERRORS_NO_STATION_CODE": "Код станции отсутствует.",
	"KN15_ERRORS_INVALID_DAY_IN_MONTH": "День в месяце должен быть числом.",
	"KN15_ERRORS_UNSUPPORTED_HOUR_CODE": "Поддерживается только 08 час.",
	"KN15_ERRORS_OUT_OF_RANGE_DAY_IN_MONTH": "День в месяце вне диапазона.",
	"KN15_ERRORS_INVALID_SECTION_CODE": "Код группы должен быть числом.",
	"KN15_ERRORS_UNSUPPORTED_SECTION_CODE": "Поддерживаются только коды групп 1 и 2",
	"KN15_ERRORS_UNSUPPORTED_SECTION": "Поддерживаются только группы 933, 966 и 988. Пожалуйста, убедитесь, что номер  идентификатора расхода воды не \"1\".",
	"KN15_ERRORS_INVALID_GROUP_ONE": "Группа 1HHHH отсутствует",
	"KN15_ERRORS_INVALID_WATER_LEVEL": "Неверный уровень воды.",
	"KN15_ERRORS_INVALID_GROUP_TWO": "Группа 2HHHK отсутствует",
	"KN15_ERRORS_INVALID_TREND": "Неверная  тенденция уровня воды.",
	"KN15_ERRORS_INVALID_GROUP_THREE": "Группа 3HHHH отсутствует",
	"KN15_ERRORS_INVALID_TEMPERATURE": "Неверная температура воды и / или воздуха.",
	"KN15_ERRORS_INVALID_ICE_PHENOMENA": "Неправильный код и / или интенсивность ледяных явлений.",
	"KN15_ERRORS_INVALID_MONTH": "Неверный номер месяца.",
	"KN15_ERRORS_INVALID_GROUP_TWO_DISCHARGE": "Группа 2kQQQ отсутствует",
	"KN15_ERRORS_INVALID_DISCHARGE_VALUE": "Неверное значение расхода воды.",
	"KN15_ERRORS_INVALID_FREE_RIVER_AREA_VALUE": "Неверное значение площади живого сечения",
	"KN15_ERRORS_INVALID_MAXIMUM_DEPTH_VALUE": "Неверное значение максимальной глубины",
	"KN15_ERRORS_INVALID_GROUP_FIVE": "Группа 5YYGG iотсутствует",
	"KN15_ERRORS_OUT_OF_RANGE_HOUR": "Час вне диапазона.",
	"PASTE_MULTIPLE_KN_15_TELEGRAMS": "Вставьте несколько телеграмм KN-15",
	"ADD_SINGLE_TELEGRAM": "Добавить одну телеграмму",
	"AUTOMATICALLY_PROCESSED_TELEGRAMS": "Автоматически обработанные телеграммы",
	"COMPLETED_TELEGRAMS": "Завершенные телеграммы",
	"TELEGRAMS_REQUIRING_ACTION": "Телеграммы, требующие действий",
	"DATA_OVERVIEW": "Обзор данных",
	"DATA_PROCESSING": "Обработка данных",
	"PRECIPITATION_NORM": "Норма осадком",
	"TEMPERATURE_NORM": "Норма температуры воздуха",
	"NO_METEOSTATION_FOR_CODE": "Нет метеостанции",
	"NO_METEOSTATION_FOR_CODE_EXTENDED": "Нет метеостанции, соответствующей гидропосту с кодом {stationCode}. Если вы не создадите метеостанцию с тем же кодом станции, метеоданные будут игнорироваться при отправке.",
	"CREATE_METEOSTATION": "Создать метеостанцию",
	"STATION_PAIR_NOTIFICATION": "Существующая {stationType} Станция ({stationCode})",
	"STATION_PAIR_NOTIFICATION_EXTENDED": "Станция {stationType} с тем же кодом станции ({stationCode}) уже существует. Последующие данные телеграммы с этим кодом станции будут автоматически отправляться для каждой станции отдельно в зависимости от ее типа.",
	"MM_DAY": "мм/день",
	"NO_DAILY_DATA": "Нет ежедневных данных",
	"NO_DISCHARGE_DATA": "Нет данных расходов воды",
	"NO_DECADAL_DATA": "Нет декадных данных",
	"ERROR": "Ошибка",
	"NEW_TELEGRAM_DATA_ENTRY": "Новая запись",
	"OLD_TELEGRAM_DATA_ENTRY": "Старая запись",
	"OVERRIDE_OLD_ENTRY": "Переопределить старую запись",
	"MANUAL_INPUT": "Ручной ввод",
	"DISCHARGE_STATIONS_WITH_MISSING_TELEGRAMS": "Гидропост с отсутствующими телеграммами",
	"METEO_STATIONS_WITH_MISSING_TELEGRAMS": "Метеостанции с отсутствующими телеграммами",
	"METEO_DATA": "Метео данные",
	"DISCHARGE_CURVE_ADJUSTMENT": "Корректировка кривой расходов воды",
	"NO_CURVE_FOR_METEO": "Кривая расходов воды недоступна для станции, имеющей только метеоданные.",
	"CATCHMENT_AREA_FILE_UPLOAD": "Загрузка файла площади бассейна",
	"STEP_4_SNOW_DATA": "Шаг 4. Данные снежного покрова",
	"SHOW_SNOW_DATA": "Показать данные снежного покрова",
	"SNOW_DATA": "Данные снежного покрова",
	"LOAD_SNOW_DATA": "Загружить данные снежного покрова",
	"FORECAST_TYPE": "Тип прогноза",
	"FORECAST_TYPE_DETAILS": "Детали типа прогноза",
	"SUBMIT_MODEL": "Принят модель",
	"SHOW_FORECAST_MODELS": "Показать модель прогноза",
	"CURRENT_CURVE_ADJUSTMENT": "Установка текущей кривой",
	"CURVE_MANAGEMENT": "Управление кривой",
	"ALL_CURVES": "Все кривые",
	"COMPLETION": "Завершение",
	"STARTED": "Начать",
	"LAST_MODIFIED": "Последнее изменение",
	"PDF_REPORT": "PDF отчет",
	"TRAINING_INFO": "Информация об обучении",
	"FEATURE_TIMELAG": "Запаздывание по времени",
	"EDIT_FORECAST_MODEL": "Изменить модель прогноза",
	"FORECAST_MODEL_SETUP": "Настройка модели прогноза",
	"FORECAST_MODEL_SETUP_EXTENDED": "Хотите сейчас настроить прогнозные модели для этой станции?",
	"NON_REVERTIBLE_ACTION": "Это необратимое действие. Вы хотите продолжить?",
	"AUTOMATICALLY_ACCEPT_FORECAST_VALUES": "Автоматически принимать прогнозные значения",
	"FORECAST_BULLETIN": "Прогнозный бюллетень",
	"CANCEL_MODEL_TRAINING": "Прерывание обучения модели",
	"CANCEL_MODEL_TRAINING_CONFIRMATION": "Вы уверены, что хотите отменить обучение модели?",
	"YES": "Да",
	"NO": "Нет",
	"VERIFY_PAYMENT": "Подтвердить платеж",
	"ENABLED_UNTIL_DATE": "Включено до {date}",
	"DISABLED": "Отключен",
	"ACCESS_REQUESTED": "Доступ запрошен",
	"ACTIONS": "Действия",
	"ACTIVATE_OR_RENEW_SUBSCRIPTIONS": "Активировать или продлить подписку",
	"PAYMENT_VERIFICATION_CONFIRMATION": "Вы уверены, что хотите подтвердить платеж  {organization}?",
	"INVITATIONS": "Приглашения",
	"REGISTER": "Регистр",
	"ISSUE_DATE_OFFSET": "Смещение даты выпуска",
	"TARGET_PERIOD_START": "Начало целевого периода",
	"TARGET_PERIOD_END": "окончание целевого периода",
	"REFRESH_TRAINING_INFO": "Обновить информацию о тренировке",
	"TIMEZONE": "Часовой пояс",
	"SELECT_TIMEZONE": "Выбор часовой пояс",
	"TEMPLATES": "Шаблоны",
	"TIMEZONE_NOTE": "Если ваша организация работает в нескольких часовых поясах, оставьте это поле пустым",
	"NO_MATCH": "Не совпадает",
	"GENERATE_PREDICTION_MANUALLY": "Генерация прогноза вручную",
	"PREDICTION_DATE": "Дата прогноза",
	"NO_CONTENT": "Без содержания",
	"BULK_DATA_DOWNLOAD": "Массовая загрузка данных",
	"GENERATE_BULK_DATA": "Генерация массовых данных",
	"REPORTING_TEMPLATES": "Шаблоны отчетов",
	"DAILY_BULLETIN": "Ежедневный бюллетень",
	"DECADAL_BULLETIN": "Декадный бюллетень",
	"TEMPLATE_TAGS": "Теги шаблона",
	"DEFAULT_TEMPLATE": "Шаблон по умолчанию",
	"CURRENT_TEMPLATE": "Текущий шаблон",
	"BULK_DATA": "Массовые данные",
	"PREPARE_BULK_DATA": "Подготовить массовых данных",
	"BULK_DATA_DATE": "Дата массовых данных",
	"DECADAL_OPERATIONAL_BULLETIN": "Декадный оперативный бюллетень",
	"NO_FORECAST_TYPES": "В организации не определены типы прогнозов.",
	"YEAR_WILL_BE_IGNORED": "Год будет игнорироваться",
	"FORECAST_TYPE_CHANGE_WARNING": "Изменение настроек типа прогноза требует обучения новой модели прогноза для тех моделей прогноза, которые основанных на измененном типе прогноза.",
	"FAILED_TO_LOAD_USER": "Не удалось загрузить пользователя",
	"FAILED_TO_LOAD_ORGANIZATIONS": "Не удалось загрузить организацию",
	"SAVE_FAILED": "Сохранить не удалось",
	"NO_STATIONS_WITH_FORECAST": "Нет станций с прогнозом",
	"NO_FORECAST_MODELS": "Нет прогнозных моделей",
	"MANUAL_DISCHARGE_INPUT": "Ручной ввод расхода воды (ледовые явления включены)",
	"MANUAL_WATER_LEVEL_INPUT": "Ручной ввод уровня воды (тенденция уровня воды отличается)",
	"MIN_TEMPLATE_TAG_NOTE": "Должен быть как минимум один тег заголовка и один тег тела.",
	"NO_DISCHARGE_CURVE_FOR_SITE_WITH_CODE": "Нет кривой расходов воды для гидропоста с кодом {siteCode}",
	"LANGUAGE": "Язык",
	"ENGLISH": "Английский",
	"RUSSIAN": "Русский",
	"LANGUAGE_NOTE": "Используется для эл.почты.",
	"WE_WILL_CONTACT_YOU_ASAP": "Мы свяжемся с вами, как только сможем!",
	"WE_ARE_SORRY": "Мы сожалеем",
	"HELP_MESSAGE_ERROR": "Из-за ошибки на нашей стороне мы не смогли отправить Ваше сообщение. Пожалуйста, попробуйте еще раз.",
	"THANK_YOU": "Спасибо",
	"CONTACT_US_FOR_HELP": "Свяжитесь с нами для помощи",
	"YOUR_NAME": "Ваше имя",
	"YOUR_EMAIL": "Ваша эл.почта",
	"MESSAGE": "Сообщение",
	"SENDING": "Отправка",
	"APP_TITLE": "Современная оперативная гидрология горных рек в Центральной Азии",
	"FILE_UPLOADED": "Файл загружен",
	"SNOW_DATA_FILE_NOTE": "Пожалуйста, переименуйте расширение файла в «.json» перед загрузкой файла.",
	"HISTORICAL_METEOSTATION_DATA": "Исторические данные по температуре воздуха и осадкам",
	"PENTAD_FORECAST_DETAILS": "(Pentad) Периодический пентадный прогноз. Дата выпуска: 1-й день Пентады +- {lag}",
	"DECADAL_FORECAST_DETAILS": "(Decadal) Периодический декадный прогноз. Дата выпуска: 1-й день Декады+- {lag}",
	"MONTHLY_FORECAST_DETAILS": "(Monthly) Периодический месячный прогноз. Дата выпуска: 1-й день Месяца +- {lag}",
	"SEARCH_STATION_CODE": "Поиск станции по индексу станции",
	"BACK_TO_STATION_LIST": "Вернуться к списку станций",
	"FIRST_PAGE": "Первая страница",
	"PREVIOUS_PAGE": "Предыдущая страница",
	"NEXT_PAGE": "Следущая страница",
	"LAST_PAGE": "Последняя страница",
	"PROCESS": "Обрабатывать",
	"SNOW_COVER_DEVELOPMENT": "Snow cover development",
	"SNOW_COVER_MAP": "Snow cover map",
	"MEAN_CATCHMENT_NDSI": "Mean Catchment NDSI",
	"NDSI_NORM": "NDSI Norm",
	"MONTHLY_VALUES": "Monthly Values",
	"CATCHMENT_AREA_SETUP": "Catchment area setup",
	"DELETE_CATCHMENT_CONFIRM": "Are you sure you want to delete the catchment area file? Please consider exporting the data if you wish to proceed because the current data won't be accessible anymore.",
	"NORMALIZED_DIFF_SNOW_INDEX_MAP": "Normalized-Difference Snow Index (NDSI) Map",
	"RED": "Red",
	"DARK_BLUE": "Dark blue",
	"LOW_NDSI": "Low NDSI",
	"HIGH_NDSI": "High NDSI",
	"NO_DATA": "нет данных",
	"CURRENT": "ток",
	"SELECT_FORECASTING_PERIOD": "Vyberite period prognozirovaniya",
	"YEAR_TYPE": "тип года",
	"HYDRO_YEAR": "гидрологический год",
	"CALENDAR_YEAR": "календарный год"
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locale-ru.json
 ** module id = 568
 ** module chunks = 0
 **/